import React from 'react';
import { IIconProps } from './utils';

export const Refresh = ({
  fill = '#000', height = 28, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 28"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M27.4145 15.772C26.7486 15.5787 26.0542 15.9582 25.8609 16.624C24.4577 21.4637 19.9545 24.8429 14.9072 24.8429C11.349 24.8429 8.0915 23.232 5.95803 20.5187L8.31344 19.6595C8.8647 19.4591 8.96493 18.7217 8.49242 18.378L2.86521 14.3473C2.44281 14.0467 1.85575 14.2614 1.72688 14.7626L0.0229688 21.4637C-0.120217 22.0364 0.431049 22.5304 0.982315 22.33L3.51671 21.4064C6.09406 25.1149 10.2894 27.3415 14.9143 27.3415C21.0642 27.3415 26.5625 23.2177 28.2736 17.3113C28.4669 16.6455 28.0803 15.951 27.4216 15.7577L27.4145 15.772Z"
      fill={fill}
    />
    <path
      d="M29.0136 5.51175L26.4792 6.4353C23.9091 2.73395 19.7137 0.500244 15.0888 0.500244C8.9318 0.500244 3.44061 4.624 1.72954 10.5233C1.53624 11.1891 1.92284 11.8835 2.5815 12.0768C2.69605 12.1126 2.81776 12.1269 2.9323 12.1269C3.47641 12.1269 3.97756 11.769 4.13507 11.2249C5.53829 6.38519 10.0415 3.006 15.0888 3.006C18.647 3.006 21.9045 4.61684 24.0379 7.33022L21.6825 8.18933C21.1312 8.38979 21.031 9.1272 21.5035 9.47085L27.1307 13.5015C27.5531 13.8022 28.1402 13.5874 28.2691 13.0863L29.9801 6.37803C30.1233 5.80529 29.5721 5.30413 29.0208 5.51175H29.0136Z"
      fill={fill}
    />
  </svg>
);
